import './toolcard.css'
import { Link } from 'react-router-dom';

const Toolcard = (props) => {
    return (
        <Link to={props.url} className="card">
            <div className="toolImage">

            </div>
            <div className='toolNameAndDesc'>
                <div className='toolName'>
                    {props.toolname}
                </div>
                <div className="toolDescription">
                    {props.description}
                </div>
            </div>
            
            <div className="toolInfo">
                <div className="toolInfoItem author">
                    {props.author}
                </div>
                <div className="toolInfoItem version">
                    {props.version}
                </div>
                <div className="toolInfoItem last-updated">
                    {props.update}
                </div>
            </div>
        </Link>
    )
}

export default Toolcard